// extracted by mini-css-extract-plugin
export default {"viewerShell":"Product3DViewer_viewerShell__mMNtS","viewerFrame":"Product3DViewer_viewerFrame__VbCB+"};